import React from 'react'
import config from 'constants/config'
import SearchHeader from 'components/Search/SearchHeader/SearchHeader'
import { isSearchEnabled } from 'lib/searchUtils'

export function LEOnboardingBlock() {
  return (
    <>
      {isSearchEnabled() && <SearchHeader
        title={config.searchFormSection.title}
      />}
    </>
  )
}

export default LEOnboardingBlock
